import React from "react";

export const Illustration9 = () => {
	return (
		<svg width={370} height={81} viewBox="0 0 370 81" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M33.3549 22.9717C-6.96243 44.9916 3.8023 69.5269 33.3549 80H345.787C389.813 44.648 334.964 10.3749 290.732 18.201C201.244 34.0344 181.142 13.276 145.613 9.46316C74.6964 1.85271 62.6464 6.97373 33.3549 22.9717Z"
				fill="#F5FAFF"
			/>
			<path d="M0 79L370 79" stroke="#315C84" strokeWidth={2} />
			<path
				d="M214 32H262C264.209 32 266 33.7909 266 36V79H210V36C210 33.7909 211.791 32 214 32Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M147 1H209C211.209 1 213 2.79086 213 5V79H143V5C143 2.79086 144.791 1 147 1Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={167} y1={15} x2={206} y2={15} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={167} y1={27} x2={192} y2={27} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={167} y1={41} x2={206} y2={41} stroke="#C4DBF1" strokeWidth={2} />
			<path
				d="M214 32.9999H262C263.657 32.9999 265 34.343 265 35.9999V42.9999H214V32.9999Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
			/>
			<line x1={167} y1={54} x2={206} y2={54} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={159} y1={69} x2={206} y2={69} stroke="#C4DBF1" strokeWidth={2} />
			<rect x={151} y={16} width={9} height={9} rx={1} fill="#C4DBF1" fillOpacity={0.49} />
			<rect x={151} y={43} width={9} height={9} rx={1} fill="#C4DBF1" fillOpacity={0.49} />
			<circle cx={65.5} cy={16.5} r={2.5} stroke="#315C84" strokeWidth={2} />
			<circle cx={343.5} cy={37.5} r={2.5} stroke="#315C84" strokeWidth={2} />
			<circle cx={66.5} cy={70.5} r={2.5} stroke="#315C84" strokeWidth={2} />
			<line x1={27} y1={62} x2={35} y2={62} stroke="#315C84" strokeWidth={2} />
			<line x1={31} y1={58} x2={31} y2={66} stroke="#315C84" strokeWidth={2} />
			<path d="M296 16H304" stroke="#315C84" strokeWidth={2} strokeLinecap="round" />
			<path d="M300 12L300 20" stroke="#315C84" strokeWidth={2} strokeLinecap="round" />
			<path d="M309 67H317" stroke="#315C84" strokeWidth={2} strokeLinecap="round" />
			<path
				d="M258.066 58.1475C257.271 58.6011 257.345 59.8104 258.192 60.162L263.125 62.2186V65.8503C263.125 66.4866 263.638 66.9999 264.275 66.9999C264.616 66.9999 264.939 66.8487 265.157 66.585L267.337 63.9729L271.692 65.787C272.357 66.0647 273.127 65.6288 273.236 64.9186L275.486 50.2936C275.553 49.8682 275.366 49.4393 275.011 49.1968C274.656 48.9542 274.192 48.9331 273.816 49.1475L258.066 58.1475ZM259.898 59.044L271.903 52.185L264.183 60.8124L264.225 60.8475L259.898 59.044ZM271.678 63.9554L265.821 61.512L273.348 53.0991L271.678 63.9554Z"
				fill="#315C84"
			/>
			<path
				d="M273.321 48.2791C274.032 47.8738 274.907 47.9141 275.576 48.3708C276.248 48.8304 276.601 49.6409 276.474 50.449L274.224 65.071C274.017 66.4187 272.575 67.2395 271.307 66.7097V66.7087L267.631 65.1785L265.926 67.2214L265.927 67.2224C265.518 67.7169 264.912 67.9996 264.275 67.9998C263.086 67.9998 262.125 67.0389 262.125 65.8503V62.8845L257.809 61.0847C256.193 60.4137 256.055 58.1437 257.57 57.2791L273.32 48.2791H273.321ZM267.504 61.1296L270.883 62.5398L271.847 56.2751L267.504 61.1296ZM262.159 58.9031L263.9 59.6287L267.049 56.1091L262.159 58.9031Z"
				fill="#315C84"
				stroke="#F9FCFF"
				strokeWidth={2}
			/>
			<path d="M313 63L313 71" stroke="#315C84" strokeWidth={2} strokeLinecap="round" />
			<line x1={221} y1={58} x2={249} y2={58} stroke="#315C84" strokeWidth={2} />
			<line x1={221} y1={66} x2={239} y2={66} stroke="#315C84" strokeWidth={2} />
			<circle
				cx={110.698}
				cy={50.777}
				r={19.5}
				transform="rotate(-1.98642 110.698 50.777)"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M110.998 41.9999C107.772 41.9999 105.189 43.4784 103.308 45.2383C101.439 46.982 100.19 49.0713 99.5988 50.5057C99.4671 50.8231 99.4671 51.1767 99.5988 51.4941C100.19 52.9284 101.439 55.0177 103.308 56.7615C105.189 58.5213 107.772 59.9999 110.998 59.9999C114.224 59.9999 116.807 58.5213 118.688 56.7615C120.557 55.0137 121.806 52.9284 122.401 51.4941C122.533 51.1767 122.533 50.8231 122.401 50.5057C121.806 49.0713 120.557 46.982 118.688 45.2383C116.807 43.4784 114.224 41.9999 110.998 41.9999ZM105.249 50.9999C105.249 49.4654 105.854 47.9938 106.932 46.9088C108.011 45.8237 109.473 45.2142 110.998 45.2142C112.523 45.2142 113.985 45.8237 115.064 46.9088C116.142 47.9938 116.748 49.4654 116.748 50.9999C116.748 52.5343 116.142 54.006 115.064 55.091C113.985 56.176 112.523 56.7856 110.998 56.7856C109.473 56.7856 108.011 56.176 106.932 55.091C105.854 54.006 105.249 52.5343 105.249 50.9999ZM110.998 48.4284C110.998 49.8468 109.852 50.9999 108.443 50.9999C108.159 50.9999 107.888 50.9517 107.632 50.8673C107.413 50.795 107.157 50.9316 107.165 51.1646C107.177 51.4418 107.217 51.7191 107.293 51.9963C107.84 54.0534 109.944 55.2749 111.988 54.7244C114.032 54.174 115.246 52.0566 114.699 49.9994C114.256 48.332 112.791 47.211 111.162 47.1427C110.93 47.1347 110.794 47.3878 110.866 47.6128C110.95 47.87 110.998 48.1432 110.998 48.4284Z"
				fill="#C4DBF1"
			/>
			<circle cx={260} cy={38.4999} r={1.5} fill="#315C84" />
			<circle cx={255} cy={38.4999} r={1.5} fill="#315C84" />
			<circle cx={250} cy={38.4999} r={1.5} fill="#315C84" />
			<path
				d="M150.5 19.9999L154 22.9999L160.5 15.9999"
				stroke="#315C84"
				strokeWidth={2}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M150.5 46.9999L154 49.9999L160.5 42.9999"
				stroke="#315C84"
				strokeWidth={2}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
